import fonts from './fonts';

const foundations = {
    fonts,
};

export default foundations;
